module.exports = __webpack_public_path__ + "img/level-2.878e4fde.svg";